import React, { Component } from 'react';
import Dialog from '../Dialog';
import EnhancedNCRForm from './EnhancedNCRForm';

class NCRDialog extends Component {
  componentDidMount() {
  }
  state = {
    hdCaseNum: null,
    activeTab: this.props.initialTab || 'ncr',
    prevInitialTab: this.props.initialTab || 'ncr',
  };

  static getDerivedStateFromProps(props, state) {
    // Update activeTab only if initialTab prop actually changed (not from user clicking tabs)
    if (props.initialTab && props.initialTab !== state.prevInitialTab) {
      return {
        activeTab: props.initialTab,
        prevInitialTab: props.initialTab,
      };
    }
    return null;
  }

  handleFormSubmitSuccess = (hdCaseNum) => {
    this.setState({ hdCaseNum, submitError: null }); // Reset error on success

    const {activeTab} = this.state;
    const formType =
      activeTab === 'ipi'
        ? 'IPI'
        : activeTab === 'customer-complaint'
          ? 'Customer Complaint'
          : 'NCR';

    if (this.props.onSubmitSuccess) {
      this.props.onSubmitSuccess({hdCaseNum, activeTab, formType});
    }

    if (this.props.onClose) {
      this.props.onClose({submitted: true});
    }
  }
  
  handleFormSubmitError = (error) => {
    this.setState({ submitError: error });
    this.showErrorAlert(error);
  }

  handleTabChange = (tab) => {
    this.setState({ activeTab: tab });
  }

  getTitle = () => {
    const { activeTab } = this.state;
    switch (activeTab) {
      case 'ipi':
        return 'Enter In-Process Issue Information';
      case 'customer-complaint':
        return 'Enter Customer Complaint Information';
      case 'ncr':
      default:
        return 'Enter Non-Conformance Information';
    }
  }

  showErrorAlert = (error) => {
    alert(error);
  }

  render() {
    const { heading, onClose, initialTab } = this.props;
    const title = this.getTitle();
    return (
      <Dialog
        className="ncr-dialog"
        title={title}
        onConfirm={onClose}
        showFooter={false}
        onDismiss={onClose}>
        <EnhancedNCRForm
          onFormSubmitSuccess={this.handleFormSubmitSuccess}
          onFormSubmitError={this.handleFormSubmitError}
          initialTab={initialTab}
          onTabChange={this.handleTabChange}
        />
      </Dialog>
    );
  }
}

export default NCRDialog;